import "./advantagesAbout.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { SectionTitle } from "../../../../components/landing/ui/SectionTitle/SectionTitle";
import { Slider } from "../../../../components/landing/ui/Slider/Slider";

type AdvantageItem = {
  icon: string;
  title: string;
  description: string;
};

export const AdvantagesAbout = () => {
  const data = useHomeContent();
  if (!data) return null;
  const sliderAria = data?.common?.sliderAria;

  const advantagesBlock = data.advantages;
  const advantages: AdvantageItem[] = Array.isArray(advantagesBlock)
    ? advantagesBlock
    : advantagesBlock?.items ?? [];
  const advantagesTitle =
    (!Array.isArray(advantagesBlock) && advantagesBlock?.title) ??
    data?.advantagesTitle ??
    "";

  const about = data.about;
  if (!advantages.length && !about) return null;

  return (
    <section
      className="oc-advAbout oc-section"
      id={about?.anchor ? String(about.anchor) : undefined}
    >
      <div className="oc-container">
        {!!advantages.length && (
          <>
            <SectionTitle title={advantagesTitle} />

            <div className="oc-advAbout__advDesktop">
              <div className="oc-advAbout__advWrap">
                {advantages.map((a, i) => (
                  <div className="oc-advAbout__advItem" key={i}>
                    <img className="oc-advAbout__advIcon" src={a.icon} alt="" />
                    <div className="oc-advAbout__advTitle">{a.title}</div>
                    <div className="oc-advAbout__advDesc">{a.description}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="oc-advAbout__advMobile">
              <Slider
                items={advantages}
                renderItem={(a) => (
                  <div className="oc-advAbout__advItem oc-advAbout__advItem--mobile">
                    <img className="oc-advAbout__advIcon" src={a.icon} alt="" />
                    <div className="oc-advAbout__advTitle">{a.title}</div>
                    <div className="oc-advAbout__advDesc">{a.description}</div>
                  </div>
                )}
                showArrows={false}
                showDots
                loop
                swipe
                gap={16}
                scrollBy={1}
                slidesToShow={1}
                autoPlay={false}
                arrowIconUrl="/assets/icons/arrow.svg"
                arrowDirection="left"
                ariaLabels={sliderAria}
              />
            </div>
          </>
        )}

        {!!about && (
          <div className="oc-advAbout__about">
            <div
              className="oc-advAbout__aboutText"
              dangerouslySetInnerHTML={{ __html: about.textHtml }}
            />

            <div className="oc-advAbout__statsCard">
              <div className="oc-advAbout__statsInner">
                {(about.tiles ?? []).map((tile: any, idx: number) => {
                  const isFull = tile.span === 2;
                  const colClass = isFull
                    ? "oc-advAbout__tile--full"
                    : "oc-advAbout__tile--half";

                  if (tile.type === "image") {
                    return (
                      <div
                        key={idx}
                        className={`oc-advAbout__tile oc-advAbout__img ${colClass}`}
                      >
                        <img src={tile.src} alt={tile.alt ?? ""} />
                      </div>
                    );
                  }

                  return (
                    <div
                      key={idx}
                      className={`oc-advAbout__tile oc-advAbout__stat ${colClass}`}
                    >
                      {tile.kicker && (
                        <div
                          className="oc-advAbout__statKicker"
                          dangerouslySetInnerHTML={{ __html: tile.kicker }}
                        />
                      )}
                      <div
                        className="oc-advAbout__statValue"
                        dangerouslySetInnerHTML={{ __html: tile.value }}
                      />
                      <div
                        className="oc-advAbout__statLabel"
                        dangerouslySetInnerHTML={{ __html: tile.label }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
